import axios from "axios";
 

// export let url = process.env.REACT_APP_API_SERVER_ADDRESS

  // if (!process.env.NODE_ENV || process.env.NODE_ENV == 'development') {
   export const  url = "https://multiscannerdemo.cyberno.ir"
    // url = "https://192.168.1.115"
  // }
  const httpService= axios.create({
    baseURL: url,
    headers: {
      "Content-type": "application/json",
      'content-type': 'multipart/form-data',
  
    }
  });
  
  const abortControllerRef = new AbortController();
  
  async function apiBase(
    url,
    options
  ) {
    const response = await httpService(url, options);
    return response.data ;
  }
  
  async function readData(
    url,
    headers
  ) {
    const options = {
      headers: headers,
      method: "GET",
    };
    return await apiBase(url, options);
  }
  
  async function createData(
    url,
    data,
    headers,
    cancelTokenSource, 
    onUpload
    
  ){
    const options = {
      headers: headers,
      method: "POST",
      data:data,
      cancelToken: cancelTokenSource?.token, // Use the cancelToken from the source if available
      onUploadProgress: onUpload,
      signal:  abortControllerRef.signal, // Provide the AbortSignal, // Provide the AbortSignal
  
    };
    return await apiBase(url, options);
  }
  export { createData, readData };
  